import React from 'react';

const FormError = ({ errorMessage }) => {
  return (
    errorMessage ? (
      <div>
        <small
          className="error-message"
          style={{
            color: 'red',
            fontSize: '12px',
            marginTop: '5px',
            display: 'block',
          }}
        >
          {errorMessage}
        </small>
      </div>
    ) : null
  );
};

export default FormError;
